var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaqIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1376",
    "data-name": "Group 1376",
    transform: "translate(-48 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_145",
    "data-name": "Rectangle 145",
    width: 24,
    height: 24,
    transform: "translate(48 0)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1166",
    "data-name": "Path 1166",
    d: "M10.5,12.5a.859.859,0,0,1-.6-.244.825.825,0,0,1-.249-.589,3.25,3.25,0,0,1,.492-1.538A3.33,3.33,0,0,1,11.319,9a1.675,1.675,0,0,0,.719-.749,1.632,1.632,0,0,0,.131-1.021,1.676,1.676,0,0,0-.472-.87,1.7,1.7,0,0,0-1.627-.436,1.713,1.713,0,0,0-.658.332,1.671,1.671,0,0,0-.451.575,1.639,1.639,0,0,0-.16.708.825.825,0,0,1-.249.589.862.862,0,0,1-1.2,0A.825.825,0,0,1,7.1,7.543a3.278,3.278,0,0,1,.318-1.409,3.342,3.342,0,0,1,.9-1.145,3.423,3.423,0,0,1,1.242-.646,3.459,3.459,0,0,1,2.726.368,3.372,3.372,0,0,1,1.018.952,3.282,3.282,0,0,1-.1,3.9,3.381,3.381,0,0,1-1.064.9,1.674,1.674,0,0,0-.534.513,1.636,1.636,0,0,0-.256.689.825.825,0,0,1-.249.589A.858.858,0,0,1,10.5,12.5Zm.674,7.3C13.01,19.076,19,16.232,19,10.036V5.727a4.105,4.105,0,0,0-.8-2.44,4.24,4.24,0,0,0-2.109-1.515L10.768.042a.853.853,0,0,0-.535,0L4.912,1.772A4.24,4.24,0,0,0,2.8,3.287,4.106,4.106,0,0,0,2,5.727v4.309c0,5.468,5.954,8.813,7.78,9.708A2.006,2.006,0,0,0,10.5,20,1.932,1.932,0,0,0,11.174,19.8ZM15.553,3.353a2.547,2.547,0,0,1,1.265.91A2.467,2.467,0,0,1,17.3,5.727v4.309c0,5.152-5.174,7.592-6.76,8.217-1.6-.787-6.84-3.7-6.84-8.217V5.727a2.467,2.467,0,0,1,.482-1.464,2.547,2.547,0,0,1,1.265-.91L10.5,1.712ZM10.5,14.166a.862.862,0,0,0-.472.14.837.837,0,0,0-.313.374.819.819,0,0,0-.048.481.829.829,0,0,0,.233.427.856.856,0,0,0,.435.228.866.866,0,0,0,.491-.047.847.847,0,0,0,.381-.307A.821.821,0,0,0,11.1,14.41.859.859,0,0,0,10.5,14.166Z",
    transform: "translate(50 2.001)",
    fill: "#15345a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqIcon);
export default __webpack_public_path__ + "static/media/faqIcon.0350b835f5fcfd7f19af27453b736a9c.svg";
export { ForwardRef as ReactComponent };